import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Logo } from "../components/Logo";
import { hwApi, hwErr } from "./hwApi";
import "../test/testTheme.css";

export default function HomeworkBridge() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token") || "";
    if (!token) { setError("Missing sign-in token — open Homework from the student portal."); return; }
    hwApi.post("/auth/bridge", { token })
      .then(() => navigate("/homework", { replace: true }))
      .catch((e) => setError(hwErr(e)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="tp-shell">
      <div className="tp-topbar"><div className="tp-topbar-inner">
        <a className="tp-brand" href="/"><Logo size={24} /><span>PRANJAL SIR <b>PHYSICS MENTOR</b></span></a>
      </div></div>
      <div className="tp-wrap" style={{ maxWidth: 520, padding: "90px 22px", textAlign: "center" }}>
        {error ? (
          <>
            <h2 className="tp-h2" style={{ fontSize: 22 }} data-testid="bridge-error">{error}</h2>
            <a className="tp-btn" href="/homework/auth" style={{ marginTop: 18 }} data-testid="bridge-login-link">Go to Homework login</a>
          </>
        ) : (
          <p className="tp-muted" data-testid="bridge-loading">Signing you into Homework…</p>
        )}
      </div>
    </div>
  );
}
